import { find, map } from 'lodash';

import { usePatientPageNavigate } from '@/Pages/SinglePatientDetails/PatientPageNavigation';

import useQuestionnairesService from '../../../../services/questionnairesService';
import type { IPatientVASQuestionaire } from '../../../../services/questionnairesService/types';
import { patientTabsUrl } from '../../../SinglePatientDetails/types';
import { vasScaleOptions } from '../RangesProps/vasRangesProps';

export default function useVASEvent(patientUuid: string) {
  const { VASQuestionnaires } = useQuestionnairesService(patientUuid);

  const questionnaires = VASQuestionnaires ?? [];
  const { navigateToPatientPage } = usePatientPageNavigate();

  return map(questionnaires, ({ vasDate, chips, rating }: IPatientVASQuestionaire) => {
    const vasScale = find(vasScaleOptions, (item) => item.rating === rating);
    return {
      name: vasScale?.text,
      date: vasDate,
      icon: () => <div className="text-primary font-bold">Pain rating</div>,
      description: (chips ?? []).join(', '),
      ctaText: 'View Pain rating',
      circle: {
        color: vasScale?.color ?? '',
        value: rating,
      },
      cta() {
        navigateToPatientPage(`/patients/${patientUuid}/${patientTabsUrl.activityLog}`);
      },
    };
  });
}
